import { MenuLabelList } from "..";
import { MenuItem } from "../elements";
import { LinkIcon, MenuItemWrap, StyledMenu } from "./elements";
import Home from "../../../assets/images/home.svg";
import Yamato from "../../../assets/images/yamato.svg";
import Question from "../../../assets/images/question.svg";
import Rule from "../../../assets/images/rule.svg";

interface Props {
  open: boolean;
}

export const Menu: React.FC<Props> = ({ open }) => {
  return (
    <StyledMenu open={open}>
      {MenuLabelList.map(({ link, label }) => (
        <MenuItemWrap key={`menu-${label}`}>
          {link === "/" && <LinkIcon src={Home} />}
          {link === "/pickup_instructions" && <LinkIcon src={Yamato} />}
          {link === "/agreement" && <LinkIcon src={Rule} />}
          {link === "/faq" && <LinkIcon src={Question} />}
          <MenuItem key={label} to={link}>
            {label}
          </MenuItem>
        </MenuItemWrap>
      ))}
    </StyledMenu>
  );
};
